import { render, staticRenderFns } from "./Anschluss.vue?vue&type=template&id=730c66fc&"
import script from "./Anschluss.vue?vue&type=script&lang=js&"
export * from "./Anschluss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports